<upp-away [_center]="center" (changeEvent)="OnChange($event)" (closeEvent)="OnClose()"></upp-away>